module.exports = __webpack_public_path__ + "img/v_up.c18d48b9.png";